(function () {
  var SELECTOR = '.join-program-card a'; // matches both "Join now" and "Sign in"

  function openKwikpass(e) {
    var link = e.target.closest ? e.target.closest(SELECTOR) : null;
    if (!link) return;

    // Stop Smile's own redirect to /account/login or /account/register
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (typeof handleKpAndShopifyLogin !== 'function') {
      console.warn('KwikPass not loaded yet');
      return;
    }

    // Close the Smile panel so the popup isn't hidden behind it
    try { if (window.SmileUI && SmileUI.closePanel) SmileUI.closePanel(); } catch (err) {}

    handleKpAndShopifyLogin(window.location.pathname);
  }

  // 1. Smile panel rendered directly on the page
  document.addEventListener('click', openKwikpass, true);

  // 2. Smile panel rendered inside an iframe
  function hookIframes() {
    document.querySelectorAll('iframe').forEach(function (frame) {
      if (frame.dataset.kpHooked) return;
      try {
        var doc = frame.contentDocument;
        if (!doc) return;
        doc.addEventListener('click', openKwikpass, true);
        frame.dataset.kpHooked = '1';
      } catch (err) { /* cross-origin iframe, can't access */ }
    });
  }

  new MutationObserver(hookIframes).observe(document.body, { childList: true, subtree: true });
  setInterval(hookIframes, 1000); // catches iframes whose content loads later
})();